module.exports = __webpack_public_path__ + "static/media/work_portland_resourcing.70f7b92c.jpg";